import {
  get,
  post,
  upload
} from '../common/request.js'
import {
  Loading
} from 'element-ui';
var url = ''
if (process.env.NODE_ENV === 'production') {
  //生产
  url = 'https://www.tyhothot.com/api/'
} else {
  //开发
  url = 'https://www.tyhothot.com/api/'
}

export function register(data) {
  //注册
  return post(url + 'user/register', data)
}
export function login(data) {
  //注册
  return post(url + 'user/login', data)
}
export function edit(data) {
  //注册
  return post(url + 'user/edit', data)
}
export function phoneList(data) {
  //注册
  return get(url + 'phone/list', data)
}
export function phoneCountryList(data) {
  //注册
  return get(url + 'phone/country', data)
}
export function getMyPhone(data) {
  //我的可用手机号
  return get(url + 'user/phones', data)
}
export function getMyMes(data) {
  //消息列表
  return get(url + 'user/msgs', data)
}
export function getRecord(data) {
  //交易列表
  return get(url + 'user/rewords', data)
}
export function getOrderList(data) {
  //订单列表
  return get(url + 'user/order_list', data)
}
export function payOrder(data) {
  //下单接口
  return post(url + 'Phone/createOrder', data)
}
export function Balancepayment(data) {
  //余额支付
  return post(url + 'Phone/pay', data)
}
export function getBlog(data) {
  //博客列表
  return post(url + 'blog/list', data)
}
export function getRentDetail(data) {
  //租赁手机号详情
  return post(url + 'phone/model_detail', data)
}
export function getrecharge(data) {
  //充值余额
  return post(url + 'user/recharge', data)
}
export function updateUserInfo(data) {
  //充值余额
  return post(url + 'user/userinfo', data)
}
export function getcontact(data) {
  //充值余额
  return post(url + 'blog/add', data)
}
export function getProvision(data) {
  //条款/常见问题
  return post(url + 'Article/detail', data)
}
//发送邮箱验证码
export function getEmailCode(data) {
  //条款/常见问题
  return post(url + 'user/sendEmail', data)
}
//修改密码
export function editPassword(data) {
  //条款/常见问题
  return post(url + 'user/changePwd', data)
}
//手机模板列表
export function getNumberModule(data) {
  //条款/常见问题
  return post(url + 'phone/models', data)
}
export function getPhoneMessage(data) {
  //短信列表
  return post(url + 'user/phone_msg', data)
}







export function bannerList(data) {
  return get(url + 'banner/list', data)
}
export function goodsList(data) {
  //商品列表
  return get(url + 'goods/list', data)
}
export function goodsIndex(data) {
  return get(url + 'goods/index', data)
}
export function goodsCates(data) {
  return get(url + 'goods/cates', data)
}
export function goodsYearList(data) {
  return get(url + 'goods/year_list', data)
}
export function ArticleList(data) {
  return get(url + 'Article/list', data)
}
export function ArticleDetail(data) {
  return get(url + 'Article/detail', data)
}
export function goodsPai(data) {
  return get(url + 'goods/pai', data)
}
export function goodsDetail(data) {
  return get(url + 'goods/detail', data)
}
export function paiDetail(data) {
  return get(url + 'pai/detail', data)
}
export function paiTimes(data) {
  return get(url + 'pai/times', data)
}
export function paiList(data) {
  return get(url + 'pai/list', data)
}
export function goodsAct(data) {
  return get(url + 'goods/act', data)
}
export function goodsAct_detail(data) {
  return get(url + 'goods/act_detail', data)
}





// WEBPACK FOOTER //
// ./src/api/api.js